import EApplicationTerm from "../../enums/EApplicationTerm";

const state = () => ({
  //show state
  showAdvancedFilters: false,
  //sme state
  sme: false,
  notSme: false,
  bothSme: false,
  smeString: "",
  //applicationTerm state
  before: false,
  after: false,
  beforeAndAfter: false,
  termOptions: [{}],
  termsString: "",
  //scope state
  selectedScopes: [],
  publicationStatusesEnums: []
});

const getters = {};

const actions = {};

const mutations = {
  //show/hide mutations
  enableAdvanced(state) {
    state.showAdvancedFilters = true;
  },
  disableAdvanced(state) {
    state.showAdvancedFilters = false;
  },

  //sme mutations
  updateSme(state, val) {
    state.sme = val;
  },
  updateNotSme(state, val) {
    state.notSme = val;
  },
  updateBothSme(state, val) {
    state.bothSme = val;
  },
  createSMEString(state) {
    state.smeString = "";
    if (state.sme) state.smeString += "10,";
    if (state.notSme) state.smeString += "20,";
    if (state.bothSme) state.smeString += "30";
    if (state.smeString[state.smeString.length - 1] == ",")
      state.smeString = state.smeString.substring(
        0,
        state.smeString.length - 1
      );
  },
  updateSelectedScopes(state, val) {
    if (state.selectedScopes.length > 0) state.selectedScopes = [];
    state.selectedScopes = val;
  },

  //terms mutations
  updateTerms(state, val) {
    state.termOptions = val;
  },
  updateTermBefore(state, val) {
    state.before = val;
  },
  updateTermAfter(state, val) {
    state.after = val;
  },
  updateTermBoth(state, val) {
    state.beforeAndAfter = val;
  },
  createTermsString(state) {
    const terms = [];

    if (state.before) terms.push(EApplicationTerm.Before);
    if (state.after) terms.push(EApplicationTerm.After);
    if (state.beforeAndAfter) {
      terms.push(EApplicationTerm.BeforeAndAfter);
    }

    state.termsString = terms.join(",");
  },
  updatePublicationStatusesEnums(state, val) {
    state.publicationStatusesEnums = val;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
